module.exports = __webpack_public_path__ + "img/Ricinus_communis.138423e1.jpg";